import { useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Logo from "./Logo";
import { adminActions } from "../store/adminSlice";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

function HeaderScaff({ setSidebarOpen }) {
  const isNonMobile = useMediaQuery("(min-width: 768px)");
  const navigate = useNavigate();
  const signOut = useSelector((state) => state.admin.signOut);
  const dispatch = useDispatch();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
    // URL'den aktif sekmeyi belirle
    const path = window.location.pathname;
    if (path.includes("archive")) setActiveTab("archive");
    else if (path.includes("pending")) setActiveTab("pending");
    else if (path.includes("approved")) setActiveTab("approved");
    else if (path.includes("declined")) setActiveTab("declined");
    else if (path.includes("liveprojects")) setActiveTab("live");
  }, []);

  const pendingQuotes = () => {
    setActiveTab("pending");
    if (!isNonMobile) {
      navigate("/pendingprojectqoutes");
      setSidebarOpen(false);
      setMobileMenuOpen(false);
    } else {
      navigate("/pendingprojectqoutes");
    }
  };

  const quotesApproved = () => {
    setActiveTab("approved");
    if (!isNonMobile) {
      navigate("/quotesapproved");
      setSidebarOpen(false);
      setMobileMenuOpen(false);
    } else {
      navigate("/quotesapproved");
    }
  };

  const quotesDeclined = () => {
    setActiveTab("declined");
    if (!isNonMobile) {
      navigate("/quotesdeclined");
      setSidebarOpen(false);
      setMobileMenuOpen(false);
    } else {
      navigate("/quotesdeclined");
    }
  };

  const liveProjects = () => {
    setActiveTab("live");
    if (!isNonMobile) {
      navigate("/liveprojects");
      setSidebarOpen(false);
      setMobileMenuOpen(false);
    } else {
      navigate("/liveprojects");
    }
  };

  const ArchivePendingQuotes = () => {
    setActiveTab("archive");
    if (!isNonMobile) {
      navigate("/archivependingprojectquotes");
      setSidebarOpen(false);
      setMobileMenuOpen(false);
    } else {
      navigate("/archivependingprojectquotes");
    }
  };

  useEffect(() => {
    dispatch(adminActions.removeSignout());
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const getTabClassName = (tabName) => {
    const baseClass =
      "px-4 py-2 text-sm font-medium transition-colors duration-200 rounded-t-lg mx-1 flex items-center justify-center";
    const activeClass = `${baseClass} bg-[#66c18a] text-white shadow-md`;
    const inactiveClass = `${baseClass} border border-b-0 hover:bg-[#e6f7ee] hover:text-[#66c18a] text-gray-700`;

    return activeTab === tabName ? activeClass : inactiveClass;
  };

  return (
    <header className="w-full bg-white shadow-sm border-b border-gray-200">
      <div className="flex justify-between items-center px-4 sm:px-6 md:px-8 py-2">
        <div className="flex-shrink-0">
          <div
            onClick={() => navigate("/liveprojects")}
            style={{ cursor: "pointer" }}
          >
            <Logo />
          </div>
        </div>

        {/* Desktop Menu - now in the same row as the logo */}
        <div className={`hidden md:flex space-x-1 items-center`}>
          <button
            className={getTabClassName("archive")}
            onClick={ArchivePendingQuotes}
          >
            Archive Quotes
          </button>
          <button
            className={getTabClassName("pending")}
            onClick={pendingQuotes}
          >
            Pending Quotes
          </button>
          <button
            className={getTabClassName("approved")}
            onClick={quotesApproved}
          >
            Quotes Approved
          </button>
          <button
            className={getTabClassName("declined")}
            onClick={quotesDeclined}
          >
            Quotes Declined
          </button>
          <button className={getTabClassName("live")} onClick={liveProjects}>
            Live Projects
          </button>
        </div>

        {/* Hamburger menü ikonu - sadece mobil ekranlarda görünür */}
        {!isNonMobile && (
          <button
            onClick={toggleMobileMenu}
            className="block md:hidden p-2 focus:outline-none rounded-md hover:bg-gray-100"
            aria-label="Menu"
          >
            {mobileMenuOpen ? (
              <CloseIcon style={{ color: "#66c18a" }} />
            ) : (
              <MenuIcon style={{ color: "#66c18a" }} />
            )}
          </button>
        )}
      </div>

      {/* Mobil Menü */}
      {!isNonMobile && mobileMenuOpen && (
        <div className="fixed inset-0 z-50 flex items-start justify-center pt-20 bg-white bg-opacity-98">
          <div className="flex flex-col w-full p-4 space-y-3">
            <button
              className={`w-full py-3 rounded-lg ${
                activeTab === "archive"
                  ? "bg-[#66c18a] text-white"
                  : "bg-white border border-gray-300 text-gray-700"
              }`}
              onClick={ArchivePendingQuotes}
            >
              Archive Quotes
            </button>
            <button
              className={`w-full py-3 rounded-lg ${
                activeTab === "pending"
                  ? "bg-[#66c18a] text-white"
                  : "bg-white border border-gray-300 text-gray-700"
              }`}
              onClick={pendingQuotes}
            >
              Pending Quotes
            </button>
            <button
              className={`w-full py-3 rounded-lg ${
                activeTab === "approved"
                  ? "bg-[#66c18a] text-white"
                  : "bg-white border border-gray-300 text-gray-700"
              }`}
              onClick={quotesApproved}
            >
              Quotes Approved
            </button>
            <button
              className={`w-full py-3 rounded-lg ${
                activeTab === "declined"
                  ? "bg-[#66c18a] text-white"
                  : "bg-white border border-gray-300 text-gray-700"
              }`}
              onClick={quotesDeclined}
            >
              Quotes Declined
            </button>
            <button
              className={`w-full py-3 rounded-lg ${
                activeTab === "live"
                  ? "bg-[#66c18a] text-white"
                  : "bg-white border border-gray-300 text-gray-700"
              }`}
              onClick={liveProjects}
            >
              Live Projects
            </button>
          </div>
        </div>
      )}
    </header>
  );
}

export default HeaderScaff;
